export default __webpack_public_path__ + "static/media/spacing-right.598a8c5a.svg";